// extracted by mini-css-extract-plugin
module.exports = {"content":"advertising_content__wL99v","upload":"advertising_upload__2yfCC","imgContainer":"advertising_imgContainer__xzDov","deleteImg":"advertising_deleteImg__2werA"};